/**
 * Pre-compiled fr-FR messages for DateRangePicker
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearInput: `Effacer la valeur saisie`,
  clearSelection: `Effacer la plage de dates`,
  endTime: `Heure de fin`,
  endTimeHour: `Heure de fin (heure)`,
  endTimeHourMinute: `Heure de fin (heure et minute)`,
  endTimeHourMinuteSecond: ` Heure de fin (heure, minute et seconde)`,
  endTimeLabel: `Heure de fin`,
  openCalendar: `Ouvrir le calendrier`,
  startTime: `Heure de début`,
  startTimeHour: `Heure de début (heure)`,
  startTimeHourMinute: `Heure de début  (heure et minute)`,
  startTimeHourMinuteSecond: `Heure de début (heure, minute et seconde)`,
  startTimeLabel: `Heure de début`,
};
